import { createMuiTheme } from '@material-ui/core';

import palette from './pallete';

const theme = createMuiTheme({
  palette,
});

export default theme;
